import { render, staticRenderFns } from "./SchoolConfig.vue?vue&type=template&id=750abf29"
import script from "./SchoolConfig.vue?vue&type=script&lang=js"
export * from "./SchoolConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports